import { isNodeInGrid } from "./general";

export function binaryTree(grid) {
  const rows = grid.length;
  const cols = grid[0].length;
  // randomly choose south or east
  for (let row = 1; row < rows; row += 2) {
    for (let col = 1; col < cols; col += 2) {
      //etch out cells with 1-cell-thick borders
      const node = grid[row][col];
      if (node.type === "obstacle") {
        node.type = "regular";
      }
      // wallNode will be randomly chosen to turn into a path
      let wallNode = null;

      // if loop is in the last row, only east
      if (!grid[row + 2]) {
        wallNode = grid[row][col + 1];
      } else {
        // if loop is in the last column, only south
        if (!grid[row][col + 2]) {
          wallNode = grid[row + 1][col];
        }
      }
      // if loop is somewhere in the start/middle
      if (grid[row + 2] && grid[row][col + 2]) {
        let wallNodes = [grid[row][col + 1], grid[row + 1][col]];
        const index = Math.floor(Math.random() * 2);
        wallNode = wallNodes[index];
      }

      if (wallNode && wallNode.type === "obstacle") {
        wallNode.type = "regular";
      }
    }
  }
}

function getNeighbourNodes(grid, node) {
  const row = node.row;
  const col = node.col;
  const neighbours = [];
  const directions = [
    [row - 2, col], // up
    [row, col + 2], // right
    [row + 2, col], // down
    [row, col - 2], // left
  ];
  for (let dir of directions) {
    if (isNodeInGrid(grid, dir[0], dir[1])) {
      neighbours.push(grid[dir[0]][dir[1]]);
    }
  }
  return neighbours;
}
function mergeAndEtchNodes(grid, n1, n2) {
  if (n1.type === "obstacle") n1.type = "regular";
  if (n2.type === "obstacle") n2.type = "regular";
  const row = (n1.row + n2.row) / 2;
  const col = (n1.col + n2.col) / 2;
  const middleNode = grid[row][col];
  if (middleNode.type === "obstacle") middleNode.type = "regular";
}

export function prims(grid, startPoint) {
  const frontierNodes = [];
  const startNode = grid[startPoint.row][startPoint.col];
  startNode.isVisited = true;
  for (let neighbour of getNeighbourNodes(grid, startNode)) {
    frontierNodes.push(neighbour);
  }
  while (frontierNodes.length) {
    const randomIndex = Math.floor(Math.random() * frontierNodes.length);
    const currentNode = frontierNodes.splice(randomIndex, 1)[0];
    const neighbours = getNeighbourNodes(grid, currentNode);
    const visitedNeighbours = [];
    for (let neighbour of neighbours) {
      if (neighbour.isVisited) visitedNeighbours.push(neighbour);
      if (!neighbour.isVisited && !frontierNodes.includes(neighbour)) {
        frontierNodes.push(neighbour);
      }
    }
    const randomVisitedNeighbourIndex = Math.floor(
      Math.random() * visitedNeighbours.length
    );
    const randomVisitedNeighbour =
      visitedNeighbours[randomVisitedNeighbourIndex];
    currentNode.isVisited = true;
    mergeAndEtchNodes(grid, currentNode, randomVisitedNeighbour);
  }
}
